import { CompanyRepository } from "core/repository";
import { BasePresenter } from "core/presenter";
import { fn } from "util";

class GeneralInfoPresenter extends BasePresenter {
  initialState() {
    return {
      loading: false,
      company: {},
      currentUser: {},
      companySearchOptions: {
        online: true,
        repository: CompanyRepository,
        order: [{ field: "slug", direction: "ASC" }],
        pagination: { page: 1, perPage: 25 },
        filter: async filter => await this.getFilter(filter)
      }
    };
  }

  async onStart() {
    const currentUser = await this.mRuntime.get("currentUser");
    this.viewModel.currentUser = currentUser;
  }

  unmaskField(value) {
    return !!value ? value.replace(/\D/g, "") : "";
  }

  async onCnpjChange() {
    const cnpj = this.unmaskField(
      this.viewModel.company.fiscal_informations.cnpj
    );

    if (cnpj.length !== 14) {
      return;
    }

    this.viewModel.loading = true;

    const response = await CompanyRepository.getCnpjInfo(cnpj);

    if (response.success) {
      const { company } = this.viewModel;
      company.email = response.email;
      company.name = response.tradingName;
      company.fiscal_informations.legal_name = response.name;
      company.address = {
        ...company.address,
        zipcode: response.zipcode,
        complement: response.addressAdditional,
        state: response.state,
        street: response.address,
        neighborhood: response.neighborhood,
        city: response.city,
        number: response.addressNumber
      };

      if (response.phone) {
        company.phone = response.phone;
      }

      if (response.cityCode) {
        company.city_code = response.cityCode;
      }
    }

    this.viewModel.loading = false;
  }

  async onSelectCompany(company) {
    this.viewModel.company.account_uuid = company.account_uuid;
    if (fn.isBlank(company.account_uuid)) {
      delete this.viewModel.company.account_uuid;
    }
  }

  async getFilter(filter) {
    const currentUser = await this.mRuntime.get("currentUser");
    return [
      {
        connector: "AND",
        field: "company_uuid",
        operation: "EQ",
        value: currentUser.company_uuid
      },
      { connector: "AND", field: "slug", operation: "LIKE", value: filter },
      {
        connector: "OR",
        field: "fiscal_informations.cnpj",
        operation: "LIKE",
        value: filter
      },
      {
        connector: "OR",
        field: "fiscal_informations.legal_name",
        operation: "LIKE",
        value: filter
      }
    ];
  }

  onEnabledChange(checked) {
    const { company } = this.viewModel;
    company.blocked = checked;
  }
}

export default GeneralInfoPresenter;



// WEBPACK FOOTER //
// ./src/components/app/registration/company/form/general-info/general-info.presenter.js